// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSRating/index.less
// module id = 1003
// module chunks = 42